module.exports = __webpack_public_path__ + "static/media/cases_brand_jardim_05.d06d8b70.jpg";